import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";

export default function ServiceProviderModal({
  show,
  onHide,
  invoiceLines = [],
  practitioners = [],
  invoicePractitionerId = "",
  setLines,
}) {
  const [lineProviders, setLineProviders] = useState({});

  // Initialize lineProviders when modal opens or invoiceLines/invoicePractitionerId change
  useEffect(() => {
    const initial = {};
    invoiceLines.forEach((line) => {
      initial[line.lineNumber] =
        line.serviceProvider?.id || invoicePractitionerId || "";
    });
    setLineProviders(initial);
  }, [invoiceLines, invoicePractitionerId]);

  // Reset to defaults when modal is shown
  useEffect(() => {
    if (show) {
      const initial = {};
      invoiceLines.forEach((line) => {
        initial[line.lineNumber] =
          line.serviceProvider?.id || invoicePractitionerId || "";
      });
      setLineProviders(initial);
    }
  }, [show]); // eslint-disable-line react-hooks/exhaustive-deps

  const practitionerOptions = practitioners.filter((p) =>
    p.role?.includes("Practitioner")
  );

  const handleSave = () => {
    setLines((prev) =>
      prev.map((line) => {
        const selectedId = lineProviders[line.lineNumber];
        const pract = practitioners.find((p) => p.id === selectedId);
        return {
          ...line,
          serviceProvider: pract
            ? { id: pract.id, firstName: pract.firstName, lastName: pract.lastName }
            : null,
        };
      })
    );
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header
        closeButton
        style={{ background: "#CFE2FF" }}
        className="rounded-0 text-primary d-flex align-items-center"
      >
        <Modal.Title as="h6" className="m-0">
          Assign Service Provider
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Row className="fw-bold mb-2 border-bottom pb-1">
          <Col xs={2}>Line #</Col>
          <Col xs={5}>Description</Col>
          <Col xs={5}>Service Provider</Col>
        </Row>

        {invoiceLines.map((line) => (
          <Row key={line.lineNumber} className="align-items-center mb-2">
            <Col xs={2}>#{line.lineNumber}</Col>
            <Col xs={5}>{line.description}</Col>
            <Col xs={5}>
              <Form.Select
                value={lineProviders[line.lineNumber] || ""}
                onChange={(e) =>
                  setLineProviders((prev) => ({
                    ...prev,
                    [line.lineNumber]: e.target.value,
                  }))
                }
              >
                <option value="">Select practitioner...</option>
                {practitionerOptions.map((p) => (
                  <option key={p.id} value={p.id}>
                    {p.firstName} {p.lastName}
                  </option>
                ))}
              </Form.Select>
            </Col>
          </Row>
        ))}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSave}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
